/**
 * Contact Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled to the contact template.
 *
 * @namespace contact
 */
import {register} from '@shopify/theme-sections';

export default register('contact', {
  onLoad() {
    const chatTriggers = document.querySelectorAll('[data-trigger-gorgias-chat]');
    chatTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (window.GorgiasChat) window.GorgiasChat.open();
      });
    });
  },
});
